<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previosMaintain" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Container Condition</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <!-- <md-layout md-gutter  v-if="delaySurveyStatus=='1'  || (designation=='employee' && departmentName=='Yard' &&  ContainerDetail.maintenanceRequest!='')" >
    <md-layout md-flex='5'>
     </md-layout>
  <h5>You Have Not Done Survey in 24 Hours.Hence You Cannot Proceed Further..!!Please Mention the reason </h5>
            </md-layout>-->
            <md-layout
              md-gutter
              v-if="delaySurveyStatus=='1'  || (designation=='manager' && departmentName=='Yard' &&  ContainerDetail.maintenanceRequest!='')"
            >
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="65">
                <md-layout md-flex="100">
                  <label>Reason For Delay Survey</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="delayReason"
                    name="delayReason"
                    v-model="ContainerDetail.delayReason"
                    :disabled="(designation=='manager' && departmentName=='Yard' || ContainerDetail.maintenanceRequest!='') ?true:false"
                  ></b-form-input>
                </md-layout>
                <!-- <span class="error" v-if="!VehicleDetail.transportName">{{transportNameError}}</span> -->
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="25">
                <md-button
                  class="md-raised md-primary md-button-color heght-1px"
                  id="addButtonLoader3"
                  v-if="designation!='manager' && departmentName=='Yard'"
                  style="margin-top:10px"
                  @click="requestForMaintain('employee')"
                  :disabled="ContainerDetail.maintenanceRequest!='' ?true:false"
                >Request For Survey</md-button>

                <md-spinner md-indeterminate id="loader3" style="display:none"></md-spinner>
              </md-layout>
            </md-layout>

            <md-layout
              md-gutter
              class="gutr"
              v-if="designation=='manager' && departmentName=='Yard' && (delaySurveyStatus=='1' || ContainerDetail.maintenanceRequest!='')"
            >
              <!---->
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label for="maintenanceRequest">Maintenance Approval Request</label>
                  <model-list-select
                    :list="maintenanceRequestList"
                    v-model="ContainerDetail.maintenanceRequest"
                    option-value="maintenanceRequestV"
                    option-text="maintenanceRequestT"
                    placeholder="Select As Required"
                    :isDisabled="designation=='manager' && departmentName=='Yard' && delaySurveyStatus=='1'?false:true"
                  ></model-list-select>
                  <!-- <md-select
                name="maintenanceRequest"
                id="maintenanceRequest"
                v-model="ContainerDetail.maintenanceRequest"
                :disabled="designation=='manager' && departmentName=='Yard' && delaySurveyStatus=='1'?false:true"
              >
                <md-option value>Select Type</md-option>
                <md-option value="Approved">Approve</md-option>
                <md-option value="Rejected">Reject</md-option>
                  </md-select>-->
                </md-layout>
                <!-- <span class="error" v-if="!clientDetail.clientType">{{clientTypeError}}</span> -->
              </md-layout>

              <md-layout md-flex="25"></md-layout>
              <md-layout md-flex="25">
                <md-button
                  class="md-raised md-primary md-button-color heght-1px"
                  id="addButtonLoader3"
                  style="margin-top:10px"
                  v-if="designation=='manager' && departmentName=='Yard' && delaySurveyStatus=='1'"
                  @click="requestForMaintain('manager')"
                >Approve</md-button>
                <md-spinner md-indeterminate id="loader3" style="display:none"></md-spinner>
              </md-layout>
            </md-layout>

            <div class=" gutr">
              <b-button
                variant="outline-info"
                size="sm"
                class="pull-right"
                :disabled="permissionStatus?true:false"
                @click="showMoreContainer"
              >{{showMoreNew==true?"Hide":"Show"}} Container Details</b-button>
              <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
            </div>
            <md-layout md-gutter class="marg-top gutr" v-if="showMoreNew==true">
              <md-layout md-flex="5"></md-layout>
              <label>Container Details:</label>
              <md-layout md-flex="30"></md-layout>
            </md-layout>

            <md-layout md-gutter v-if="showMoreNew==true">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Container Size/Type</label>

                  <b-form-input :formatter="capitalizeAll"
                    id="containerTypeId"
                    name="containerTypeId"
                    v-model="ContainerDetail.containerTypeId"
                    disabled
                  ></b-form-input>
                </md-layout>

                <!-- <span class="error" v-if="!ContainerDetail.containerNo">{{containerNoError}}</span>  -->
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <md-layout md-flex="100">
                  <label>Gross Wgt.</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="grossWeight"
                    name="grossWeight"
                    v-model="ContainerDetail.grossWeight"
                    disabled
                  ></b-form-input>
                </md-layout>
                <!-- <span class="error" v-if="!ContainerDetail.tareWeight">{{tareWeightError}}</span>  -->
                <!-- <span class="error" v-if="!stockInDetails.qualityCheck">{{qualityCheckError}}</span> -->
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="10">
                <md-layout md-flex="100">
                  <label>Tare Wgt.</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="tareWeight"
                    name="tareWeight"
                    v-model="ContainerDetail.tareWeight"
                    disabled
                  ></b-form-input>
                </md-layout>

                <!-- <span class="error" v-if="!ContainerDetail.grossWeight">{{grossWeightError}}</span> -->
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Manufacturing Month-Year</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="manufractureYear"
                    name="manufractureYear"
                    v-model="ContainerDetail.manufractureYear"
                    disabled
                  ></b-form-input>
                </md-layout>
                <!-- <span class="error" v-if="!ContainerDetail.manufractureYear">{{manufractureYearError}}</span>  -->
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr" v-if="showMoreNew==true">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Container Number</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="containerNo"
                    name="containerNo"
                    v-model="ContainerDetail.containerNo"
                    disabled
                  ></b-form-input>
                </md-layout>

                <!-- <span class="error" v-if="!ContainerDetail.containerTypeId">{{containerTypeIdError}}</span> 
                -->
              </md-layout>

              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Vehicle No.</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="vehicleNo"
                    name="vehicleNo"
                    v-model="ContainerDetail.vehicleNo"
                    disabled
                  ></b-form-input>
                </md-layout>

                <!-- <span class="error" v-if="!ContainerDetail.vehicleNo">{{vehicleNoError}}</span>  -->
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Transport Name</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="transportName"
                    name="transportName"
                    v-model="ContainerDetail.transportName"
                    disabled
                  ></b-form-input>
                </md-layout>

                <!-- <span class="error" v-if="!ContainerDetail.grossWeight">{{grossWeightError}}</span> -->
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr" v-if="ContainerDetail.delaySurveyStatus!='1'">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <label for="repairStatus">Repair Status</label>
                <model-list-select
                  option-value="repairStatusV"
                  option-text="repairStatusT"
                  :list="repairStatusList"
                  v-model="ContainerDetail.repairStatus"
                  placeholder="Select Repair Status "
                  :isDisabled="ContainerDetail.estimationAmount!=''?true:false"
                ></model-list-select>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="25">
                <md-input-container>
                  <label>Upload</label>
                  <md-file
                    name="uploadboe"
                    id="boe"
                    v-model="ContainerDetail.uploadRepair"
                    @selected="onFileChangeBoe('uploadRepair')"
                    multiple
                  ></md-file>
                </md-input-container>
              </md-layout>
                <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Survey Date</label>
                    <date-picker :format="selectDateFormat" lang="en" v-model="ContainerDetail.surveyDate" id="surveyDate"></date-picker>
                
                </md-layout>
                </md-layout>
            </md-layout>

            <md-layout md-gutter v-if="firstBlUploadView2.length>0" style="margin-top:1%">
              <md-layout md-flex="40"></md-layout>
              <md-layout md-flex="5" v-for="(item,index) in firstBlUploadView2" :key="index">
                <a
                  :href="`${this.docURL}/containerCondition/`+item"
                  target="_blank"
                  download
                >File - {{index+1}}</a>
              </md-layout>
            </md-layout>
            <!-- <div v-if="degination!='manager'"> -->
            <b-container class="gutr" v-if="ContainerDetail.repairStatus=='Required' && approvedAlready!='Approved'">
              <b-card>
                <md-layout
                  md-gutter
                  v-if="ContainerDetail.repairStatus=='Required' && approvedAlready!='Approved'"
                >
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="35">
                    <label for="repairId">Repair Condition</label>
                    <model-list-select
                      option-value="repairId"
                      option-text="repairCondition"
                      :list="mainRepairList"
                      v-model="subContainer.repairId"
                      placeholder="Select Repair Condition"
                      :isDisabled="subContainer.updateConditionId!=''?true:false"
                    ></model-list-select>

                    <span class="error" v-if="!subContainer.repairId">{{containerConditionError}}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="40">
                    <label for="repairSideId">Repair Side-Condition</label>
                    <model-list-select
                      option-value="repairSideId"
                      option-text="repairSideName"
                      :list="sideRepairList"
                      v-model="subContainer.repairSideId"
                      placeholder="Select Side-Condition"
                      :isDisabled="subContainer.repairId==''?true:false"
                    ></model-list-select>
                    <span class="error" v-if="!subContainer.repairSideId">{{repairSideIdError}}</span>
                  </md-layout>
                </md-layout>
                <md-layout
                  class="gutr"
                  md-gutter
                  v-if="ContainerDetail.repairStatus=='Required' && approvedAlready!='Approved'"
                >
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="90">
                    <label for="repairSubId">Repair Sub-Condition</label>
                    <model-list-select
                      option-value="repairSubId"
                      option-text="repairSubName"
                      :list="subRepairList"
                      v-model="subContainer.repairSubId"
                      placeholder="Select Sub-Condition"
                      :isDisabled="subContainer.repairSideId==''?true:false"
                    ></model-list-select>

                    <span class="error" v-if="!subContainer.repairSubId">{{subConditionError}}</span>
                  </md-layout>
                </md-layout>

                <md-layout
                  class="gutr"
                  md-gutter
                  v-if="ContainerDetail.repairStatus=='Required' && approvedAlready!='Approved'"
                >
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="60">
                    <label for="subContainerCondition">Remark</label>
                    <b-textarea
                      v-model="subContainer.containerRemark"
                      :disabled="subContainer.updateConditionId!=''?true:false"
                    ></b-textarea>
                  </md-layout>

                  <md-layout md-flex="10"></md-layout>
                </md-layout>

                <div v-if=" designation=='manager' && subContainer.updateConditionId!=''">
                  <md-layout
                    md-gutter
                    v-if="(delaySurveyStatus=='' || designation=='manager') && ContainerDetail.repairStatus=='Required' "
                  >
                    <md-layout md-flex="5" v-if="designation=='manager'"></md-layout>

                    <md-layout md-flex="15" v-if="designation=='manager'">
                      <md-layout md-flex="100">
                        <label>Amount</label>
                        <b-form-input :formatter="capitalizeAll"
                          type="number"
                          id="materialCost"
                          name="materialCost"
                          v-model="subContainer.materialCost"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="25">
                      <label for="status">Repair Status</label>
                      <model-list-select
                        option-value="shippingApprovalV"
                        option-text="shippingApprovalT"
                        :list="shippingApprovalList"
                        placeholder="Select Approval Status"
                        v-model="subContainer.status"
                      ></model-list-select>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="15">
                      <md-layout md-flex="100">
                        <label>Approval Amount</label>
                        <b-form-input :formatter="capitalizeAll"
                          type="number"
                          id="approvalAmount"
                          name="approvalAmount"
                          v-model="subContainer.approvalAmount"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20">
                      <label>Repair Remark</label>
                      <b-textarea v-model="subContainer.managerRemark"></b-textarea>
                      <!-- <span class="error" v-if="!maintain.approvedDate" >{{approvedDateError}} </span> -->
                    </md-layout>
                  </md-layout>

                  <!-- <md-layout md-gutter>
            <md-layout md-flex="80"></md-layout>
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="mailToShippingLine"
              id="addButtonLoader5"
              style="margin-top:20px"
              v-if="ContainerDetail.estimationAmount!='' && ContainerDetail.shippingApproval=='' || ContainerDetail.shippingApproval=='Rejected' "
            >Send For Approval</md-button>
            <md-spinner md-indeterminate id="loader5" style="display:none"></md-spinner>
                  </md-layout>-->
                </div>

                <md-layout
                  class="gutr"
                  md-gutter
                  v-if="ContainerDetail.repairStatus=='Required' && approvedAlready!='Approved'"
                >
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <b-button
                      variant="info"
                      size="sm"
                      @click="updateContainerCondition"
                    >{{subContainer.updateConditionId!=""?"Edit":"Add"}}</b-button>
                  </md-layout>
                </md-layout>

                <div class="box" v-if="subConditionArray.length>0">
                  <div class="box-header">
                    <label class="box-title">
                      Container No.
                      <u>{{this.ContainerDetail.containerNo}}</u> Details
                    </label>
                  </div>

                  <!-- /.box-header -->
                  <div class="box-body">
                    <table id="tariff" class="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>Sr No.</th>
                          <th>Repair Condition</th>
                          <th>Repair Side-Condition</th>
                          <th>Repair Sub-Condition</th>
                          <th>Remark</th>
                          <th v-if="designation=='manager'">Amount</th>
                          <th v-if="designation=='manager'">Approval Amount</th>
                          <th>Status</th>

                          <th v-if="ContainerDetail.shippingApproval!='Approved'">Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr></tr>
                        <tr v-for="(item,index) in subConditionArray" :key="index">
                          <td>{{index+1}}</td>
                          <td
                            class="showMoreData"
                            @click="editContainer1(item)"
                          >{{item.repairCondition}}</td>
                          <td>{{item.repairSideName}}</td>
                          <td>{{item.repairSubName}}</td>
                          <td>{{item.containerRemark}}</td>
                          <th v-if="designation=='manager'">{{item.materialCost}}</th>
                          <th v-if="designation=='manager'">{{item.approvalAmount}}</th>
                          <td
                            :style="item.status=='Approved'?'color:green':'color:red'"
                          >{{item.status==''?"Sent For Approval":item.status}}</td>

                          <td v-if="ContainerDetail.shippingApproval!='Approved'">
                            <md-button
                              class="md-icon-button md-raised md-dense"
                              @click="deleteData(item.updateConditionId)"
                            >
                              <md-icon>delete_sweep</md-icon>
                            </md-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- /.box-body -->
                </div>
              </b-card>
            </b-container>
            <div v-if=" designation=='manager'">
              <md-layout
                md-gutter
                v-if="(delaySurveyStatus=='' || designation=='manager') && ContainerDetail.repairStatus=='Required' "
              >
                <md-layout md-flex="5" v-if="designation=='manager'"></md-layout>

                <md-layout md-flex="15" v-if="designation=='manager'">
                  <md-layout md-flex="100">
                    <label>Estimation Amount</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="estimationAmount"
                      name="estimationAmount"
                      v-model="ContainerDetail.estimationAmount"
                      disabled
                    ></b-form-input>
                  </md-layout>
                  <span
                    class="error"
                    v-if="!ContainerDetail.estimationAmount"
                  >{{estimationAmountError}}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label>Estimation Date</label>
                  <date-picker
                  :format="selectDateFormat"
                    lang="en"
                    v-model="ContainerDetail.estimationDate"
                    id="estimationDate"
                  ></date-picker>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label for="status">Approval Status</label>
                  <model-list-select
                    option-value="shippingApprovalV"
                    option-text="shippingApprovalT"
                    :list="shippingApprovalList"
                    :isDisabled="approvedAlready=='Approved'?true:false"
                    placeholder="Select Approval Status"
                    v-model="ContainerDetail.shippingApproval"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="15">
                  <md-layout md-flex="100">
                    <label>Approval Amount</label>
                    <b-form-input :formatter="capitalizeAll"
                      type="number"
                      id="approvalAmount"
                      name="approvalAmount"
                      v-model="ContainerDetail.approvalAmount"
                      :disabled="approvedAlready=='Approved'?true:false"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label>Approved Date</label>
                  <date-picker
                  :format="selectDateFormat"
                    lang="en"
                    v-model="ContainerDetail.approvedDate"
                    :disabled="permissionStatus"
                    id="Date"
                  ></date-picker>
                  <!-- <span class="error" v-if="!maintain.approvedDate" >{{approvedDateError}} </span> -->
                </md-layout>
              </md-layout>

              <!-- <md-layout md-gutter>
            <md-layout md-flex="80"></md-layout>
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="mailToShippingLine"
              id="addButtonLoader5"
              style="margin-top:20px"
              v-if="ContainerDetail.estimationAmount!='' && ContainerDetail.shippingApproval=='' || ContainerDetail.shippingApproval=='Rejected' "
            >Send For Approval</md-button>
            <md-spinner md-indeterminate id="loader5" style="display:none"></md-spinner>
              </md-layout>-->
            </div>

            <md-layout
              class="gutr"
              md-gutter
              v-if="designation=='surveyer' && approvedAlready=='Approved'"
            >
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <label for="repairCompletedNot">Repair Status</label>
                <model-list-select
                  option-value="repairCompletedNotV"
                  option-text="repairCompletedNotT"
                  :list="repairCompletedNotList"
                  placeholder="Select Repair Status"
                  v-model="ContainerDetail.repairCompletedNot"
                ></model-list-select>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Repair Date</label>
                <date-picker :format="selectDateFormat" lang="en" v-model="ContainerDetail.repairDate" id="Date"></date-picker>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="25" v-if="ContainerDetail.repairCompletedNot=='Repair_Done'">
                <md-input-container>
                  <label>Upload</label>
                  <md-file
                    name="uploadboe"
                    id="boe"
                    v-model="ContainerDetail.uploadRepairDone"
                    @selected="onFileChangeBoe('uploadRepairDone')"
                    multiple
                  ></md-file>
                </md-input-container>
                <span class="error" v-if="!ContainerDetail.uploadRepairDone">{{uploadFileError}}</span>
              </md-layout>
            </md-layout>
            <md-layout
              md-gutter
              v-if="firstBlUploadView.length>0  && ContainerDetail.repairCompletedNot=='Repair_Done' && designation=='surveyer' && approvedAlready=='Approved'"
              style="margin-top:1%"
            >
              <md-layout md-flex="60"></md-layout>
              <md-layout md-flex="5" v-for="(item,index) in firstBlUploadView" :key="index">
                <a
                  :href="`${this.docURL}/containerCondition/`+item"
                  target="_blank"
                  download
                >File - {{index+1}}</a>
              </md-layout>
            </md-layout>

            <md-layout
              md-gutter
              v-if="(ContainerDetail.delaySurveyStatus!='1') || ContainerDetail.repairStatus=='Not_Required'"
            >
              <md-layout md-flex="40"></md-layout>
              <md-layout md-flex="15">
                <b-button variant="primary" style="margin-top:30px" @click="UpdateSurvey">Submit</b-button>
              </md-layout>
            </md-layout>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPopSub"
    ></md-dialog-confirm>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
      @close="onClose"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopSubCon"
      @close="onClose1"
    ></md-dialog-alert>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop1"
      @close="onClose1"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22222"
      @close="onClose22222"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop110"
      @close="onClose110"
    ></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Yard")) {
      this.$store.dispatch("setCurrentRoute", "/yard/GateIn");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      selectDateFormat,
      isLoading: true,
      repairStatusList: [
        {
          repairStatusT: "Required",
          repairStatusV: "Required"
        },
        {
          repairStatusT: "Not Required",
          repairStatusV: "Not_Required"
        }
      ],
      docURL: URL_BASE_DOC,
      repairCompletedNotList: [
        {
          repairCompletedNotV: "In_Progress",
          repairCompletedNotT: "In Progress"
        },
        {
          repairCompletedNotV: "Repair_Done",
          repairCompletedNotT: "Repair Done"
        }
      ],

      shippingApprovalList: [
        {
          shippingApprovalV: "Approved",
          shippingApprovalT: "Approved"
        },
        {
          shippingApprovalV: "On_Hold",
          shippingApprovalT: "On Hold"
        },
        {
          shippingApprovalV: "Rejected",
          shippingApprovalT: "Rejected"
        }
      ],

      maintenanceRequestList: [
        {
          maintenanceRequestV: "Approved",
          maintenanceRequestT: "Approve"
        },
        {
          maintenanceRequestV: "Rejected",
          maintenanceRequestT: "Reject"
        }
      ],
      amountArray: [],

      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") != "" &&
        this.$sessionsStorage.get("PermissionStatus") &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,
      alert: {
        content:
          this.$sessionsStorage.get("editPOId") != "" &&
          this.$sessionsStorage.get("editPOId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      subContainer: {
        repairSideId: "",
        repairId: "",
        repairSubId: "",

        updateConditionId: "",
        materialCost: "",
        status: "",
        approvalAmount: "",
        managerRemark: "",
        containerCondition: "",
        containerConditionId: "",
        subContainerCondition: "",
        containerRemark: "",
        gateInId: this.$sessionsStorage.get("editGateInId"),
        containerGateInId: this.$sessionsStorage.get("editContainerId")
      },
      approvedAlready: "",
      mainRepairList: [],
      sideRepairList: [],
      subRepairList: [],
      tempsubRepairList: [],
      shippingDetailsNew: [
        // {
        //   containerCondition: "Floor",
        //   containerConditionId: "Floor"
        // },
        // {
        //   containerCondition: "Damage",
        //   containerConditionId: "Damage"
        // },
        // {
        //   containerCondition: "Dirty",
        //   containerConditionId: "Dirty"
        // }
      ],
      subContainorConditionNew: [],

      ContainerDetail: {
        surveyDate:"",
        estimationDate: "",
        containerGateInId: "",
        containerNo: "",
        containerTypeId: "",
        delayReason: "",
        maintenanceRequest: "",
        repairStatus: "",
        tareWeight: "",
        manufractureYear: "",
        containerCondition: "",
        sealNo: "",
        remark: "",
        grossWeight: "",
        gateInId: "",
        vehicleNo: "",
        vehicleTruckId: "",
        itemMasterId: "",
        estimationAmount: "",
        approvalAmount: "",
        shippingApproval: "",
        approvedDate: "",
        repairDate: "",
        repairCompletedNot: "",
        transportName: "",
        uploadRepair: "",
        uploadRepairDone: ""
      },
      showMoreNew: false,
      showMoreNewItem: false,
      maintain: {
        surveyDate: "",
        approvedDate: "",
        repairDate: "",
        gateInSeries: "",
        estimationAmount: "",
        approvalAmount: "",

        status: "",
        gateInId: "",
        itemMasterId: "",
        maintainenceId: "",
        containerGateInId: ""
      },
      surveyDateError: "",
      statusError: "",
      gateInSeriesError: "",
      approvedDateError: "",
      repairDateError: "",
      estimationAmountError: "",
      approvalAmountError: "",
      itemModal: {
        itemMaintainenceId: "",
        maintainenceId: "",
        containerGateInId: "",
        itemId: "",
        itemNameCode: "",
        poOrderId: "",
        itemCode: "",
        itemName: "",
        ratePerUnit: "",
        itemQuantity: "",
        totalAmount: ""
        //  total: ""
      },
      departmentName: "",
      designation: "",
      delaySurveyStatus: "",
      stockInDetails: {
        poOrderId: "",
        poItemId: "",
        maintenanceType: "",
        itemId: "",
        location: "",
        addedByPerson: "",
        department: "",
        poDate: "",
        uploadPoDoc: "",
        vendorName: "",
        specificPoDetail: ""
      },

      validate: true,

      maintenanceTypeError: "",
      locationError: "",
      addedByPersonError: "",
      departmentError: "",
      poDateError: "",
      vendorNamError: "",
      employeeMaster: [
        {
          employeeName: "ajit"
        }
      ],
      // locationMaster: [
      //   {
      //     pickupLocation: "mumbai"
      //   }
      // ],
      vendorMaster: [],
      departmentMaster: [],

      itemDetail: [
        {
          itemCode: "ajit"
        }
      ],
      locationDetail: [{}],
      dapartmentDetail: [],
      vendorDetail: [],
      subContainorCondition: [],
      itemArrayShow: [],
      subConditionArray: [],
      itemNameError: "",
      ratePerUnitError: "",
      itemQuantityError: "",
      itemCodeError: "",
      subConditionError: "",
      repairSideIdError: "",
      materialCostError: "",
      containerConditionError: "",

      allContainerDetail: [],
      uploadFileError: "",

      editVar: {
        Inputval:
          this.$sessionsStorage.get("editContainerId") != "" &&
          this.$sessionsStorage.get("editContainerId") != undefined
            ? "Update"
            : "Submit",
        FormVal:
          this.$sessionsStorage.get("editContainerId") != "" &&
          this.$sessionsStorage.get("editContainerId") != undefined
            ? "Update"
            : "New"
      }
    };
  },

  mounted() {},
  watch: {
    subContainer: {
      handler: function(newVal, oldVal) {
        if (this.subContainer.repairId != "") {
          let array = this.tempsubRepairList.filter(x => {
            return x.repairId == this.subContainer.repairId;
          });

          let obj = [];
          let obj2 = [];

          array.map(x => {
            let i = obj.indexOf(x.repairSideId);
            if (i < 0) {
              obj2.push(x);
              obj.push(x.repairSideId);
            }
          });

          this.sideRepairList = obj2;
        }

        if (
          this.subContainer.repairId != "" &&
          this.subContainer.repairSideId != ""
        ) {
          let arraySub = this.tempsubRepairList.filter(x => {
            return (
              x.repairId == this.subContainer.repairId &&
              x.repairSideId == this.subContainer.repairSideId
            );
          });

          this.subRepairList = arraySub;
        }
      },
      deep: true
    }
  },
  beforeDestroy() {
    // this.$sessionsStorage.set("editPOId", "");
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading
    CustomLoader,
  },
  computed: {
    viewDocument() {
      return this.stockInDetails.uploadPoDoc.split(",");
    },

    viewEstimatedAmount() {
      if (this.subConditionArray.length > 0) {
        let amount = 0;
        let approvalAmountC = 0;

        this.subConditionArray.map(x => {
          amount = amount + x.materialCost;
          approvalAmountC = approvalAmountC + x.approvalAmount;
        });

        console.log(amount, approvalAmountC);
        this.ContainerDetail.estimationAmount = amount;
        this.ContainerDetail.approvalAmount = approvalAmountC;
      }
    },

    firstBlUploadView() {
      return this.ContainerDetail.uploadRepairDone != ""
        ? this.ContainerDetail.uploadRepairDone.split(",")
        : [];
    },
    firstBlUploadView2() {
      return this.ContainerDetail.uploadRepair != ""
        ? this.ContainerDetail.uploadRepair.split(",")
        : [];
    },

    itemMasterList() {
      return this.itemDetail;
    },
    // locationMasterList() {
    //   return this.locationMaster;
    // },
    employeeMasterList() {
      return this.employeeMaster;
    }
  },
  methods: {
    onFileChangeBoe(id) {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: this.$sessionsStorage.get("editContainerId") + "-" + id
        }
      };

      axios
        .post(`${URL_BASE}/Api_Yard/uploadRepairContainer.php`, formData, config)
        .then(result => {
          if (id == "uploadRepair") {
            this.ContainerDetail.uploadRepair = result.data;
          } else {
            this.ContainerDetail.uploadRepairDone = result.data;
          }
          // console.log("fdsf", result.data);
        })
        .catch(err => {
          throw err;
        });
    },
    showMoreContainer() {
      if (this.showMoreNew == false) {
        this.showMoreNew = true;
      } else {
        this.showMoreNew = false;
      }
    },
    showMoreItem() {
      if (this.showMoreNewItem == false) {
        this.showMoreNewItem = true;
      } else {
        this.showMoreNewItem = false;
      }
    },

    UpdateSurvey() {
      this.validateSurvey();

      if (this.validate != false) {
        $("#addButtonLoader10").css("display", "none");
        $("#loader10").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Yard/addGateInContainer.php`,
          data: JSON.stringify(this.ContainerDetail),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              $("#loader10").css("display", "none");
              $("#addButtonLoader10").css("display", "block");
              this.alert.content = "Data Added Successfully";
              this.$refs["addPop110"].open();
            }
          })
          .catch(error => {});
      }
    },
    onClose110() {
      this.$router.push({
        path: "/yard/viewGateIn"
      });
    },
    mailToShippingLine() {
      let payload = {
        sendMail: "sendMail",
        gateInId: this.$sessionsStorage.get("editGateInId"),
        containerGateInId: this.$sessionsStorage.get("editContainerId"),
        estimationAmount: this.ContainerDetail.estimationAmount
      };

      $("#addButtonLoader5").css("display", "none");
      $("#loader5").css("display", "block");
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/mailToShippingLine.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          $("#addButtonLoader5").css("display", "block");
          $("#loader5").css("display", "none");
          this.alert.content = "Mail Sent";
          this.$refs["addPop22222"].open();
        })

        .catch(error => {});
    },
    onClose22222(type) {
      this.viewEditServiceEstimation1();
    },
    viewModalPage(itemID) {
      let array = this.itemArrayShow.filter(x => {
        return x.poItemId == itemID;
      });

      Object.keys(array[0]).map(x => {
        this.itemModal[x] = array[0][x] || "";
      });
      this.itemModal.itemNameCode =
        this.itemModal.itemName + "-" + this.itemModal.itemCode;
    },

    deleteData(subConID) {
      this.updateConditionId = subConID;
      this.alert.content = "Are you sure you want to delete this item?";
      this.$refs["addPopSub"].open();
    },
    editContainer1(item) {
      Object.keys(this.subContainer).map(x => {
        this.subContainer[x] = item[x] || "";
      });
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "yard_updatecontainercondition",
          tableId: "updateConditionId",
          tableVal: this.updateConditionId
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Yard/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (
              data.clientId != "" &&
              
              status == 200 &&
              data
            ) {
              this.onClose1();
             
              this.getData();
            }
          })
          .catch(error => {});
      }
    },
    // onClose22(){

    // this.alert.content="Data Added Successfully";
    //    this.onClose1()
    // },
    viewEditServiceEstimation() {
      let edit_SE = {
        editClient: "editClient",
        gateInId: this.$sessionsStorage.get("editGateInId")
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/viewEditGateIn.php`,
        data: JSON.stringify(edit_SE),

        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;

          if ( status == 200 && data) {
            Object.keys(data.editClient[0]).map(x => {
              this.VehicleDetail[x] = data.editClient[0][x] || "";
            });

            this.VehicleDetail.containerGateInId += ",";

            this.showServiceEst(this.VehicleDetail.containerGateInId);
          }
        })
        .catch(error => {});
    },

    finalAmount() {
      let amount =
        parseFloat(this.itemModal.ratePerUnit) *
        parseFloat(this.itemModal.itemQuantity);
      this.itemModal.totalAmount = amount;
    },
    JqueryFun() {
      return $(function() {
        $("#tariff").DataTable();
        $("#MaintainenceTable123").DataTable();
      });
    },
    validateModal() {
      let validate_new = true;

      if (this.itemModal.itemCode == "") {
        $("#itemCode").focus();
        this.itemCodeError = "Enter Item Code";
        validate_new = false;
      }
      if (this.itemModal.itemQuantity == "") {
        $("#itemQuantity").focus();
        this.itemQuantityError = "Enter Quantity ";
        validate_new = false;
      }
      if (this.itemModal.ratePerUnit == "") {
        $("#ratePerUnit").focus();
        this.ratePerUnitError = "Enter  Rate per unit";
        validate_new = false;
      }
      if (this.itemModal.itemName == "") {
        $("#itemName").focus();
        this.itemNameError = "Enter item name";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addStockFrom(Id) {
      this.$sessionsStorage.set("editPOId", Id);

      this.$router.push({
        path: "/stockIn"
      });
    },

    findItemCode(item) {
      this.itemModal.itemName = item.itemName;
      this.itemModal.ratePerUnit = item.ratePerUnit;
      this.itemModal.itemId = item.itemId;
      this.itemModal.itemCode = item.itemCode;
    },
    getData() {
      this.isLoading = true;
      let vehicle_drive = {
        itemCode: "itemCode",
        editContainerId: this.$sessionsStorage.get("editContainerId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/fetchToMaintainenceIn.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.repairMainCondition.length > 0) {
              this.mainRepairList = data.repairMainCondition;
            }

            if (data.repairSubCondition.length > 0) {
              this.subRepairList = data.repairSubCondition;
              this.tempsubRepairList = data.repairSubCondition;
            }

            this.departmentName =
              this.$sessionsStorage.get("userLevel") == "1"
                ? "Yard"
                : data.UserDetail[0].departmentName;

            this.designation =
              this.$sessionsStorage.get("userLevel") == "1"
                ? "manager"
                : data.UserDetail[0].designation;
            if (
              this.$sessionsStorage.get("editContainerId") != undefined &&
              this.$sessionsStorage.get("editContainerId") != ""
            ) {
              // this.viewStockDetail();viewEditServiceEstimation1
              this.viewEditServiceEstimation1();
            }

            
            this.isLoading = false;
            //  this.viewEditServiceEstimation();
     
          }
        })
        .catch(error => {});
    },

    viewEditServiceEstimation1() {
      let edit_SE = {
        editClient: "editClient",
        gateInId: this.$sessionsStorage.get("editGateInId")
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/viewEditGateIn.php`,
        data: JSON.stringify(edit_SE),

        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;

          if ( status == 200 && data) {
            this.showServiceEst(
              this.$sessionsStorage.get("editContainerId"),
              data.editClient[0].shippingId
            );
          }
        })
        .catch(error => {});
    },

    showServiceEst(serviceid, shippingId) {
      let payload = {
        containerGateInId: serviceid,
        gateInId: "",
        shippingId: shippingId
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/viewSubContainer.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.itemArray.length > 0) {
              this.allContainerDetail = data.itemArray;
            }

            Object.keys(data.itemArray[0]).map(x => {
              this.ContainerDetail[x] = data.itemArray[0][x] || "";
            });

            this.approvedAlready = data.itemArray[0].shippingApproval;

            if (data.itemArray[0].delaySurveyStatus == 1) {
              this.delaySurveyStatus = 1;
            }

            this.ContainerDetail.containerCondition =
              data.itemArray[0].finalcontainerCondition;

            this.onClose1();

          
            // this.$refs["addPop1"].close();
          }
        })
        .catch(error => {});
    },

    addItem() {
      this.itemModal[
        "containerGateInId"
      ] = this.ContainerDetail.containerGateInId;
      this.itemModal["gateInId"] = this.ContainerDetail.gateInId;

      this.validateModal();
      if (this.validate != false) {
        // this.$refs["dialog2"].close();
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Yard/addMaintanenceItem.php`,
          data: JSON.stringify(this.itemModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              this.ContainerDetail.itemMasterId += data.Id + ",";

              Object.keys(this.itemModal).map(x => {
                this.itemModal[x] = "";
              });
              this.itemNameError = "";
              this.itemCodeError = "";
              this.ratePerUnitError = "";
              this.itemQuantityError = "";

              // this.alert.content = "Added Succesfully";
              // this.$refs["addPop1"].open();
              this.onClose1();
            }
          })
          .catch(error => {});
      }
    },
    onClose(type) {
      //   this.$router.push({
      //     path: "/poOrder/viewPoOrder"
      //   });
    },
    onClose1() {
      this.itemArrayShow = [];
      this.subConditionArray = [];

      let payload = {};
      payload["containerGateInId"] = this.ContainerDetail.containerGateInId;

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/viewMaintainenceItem.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.containSubCondition.length > 0) {
              this.subConditionArray = data.containSubCondition;
            }

            if (data.estimstionAmount != "") {
              this.ContainerDetail.estimationAmount = data.estimstionAmount;
              this.ContainerDetail.approvalAmount = data.approvalAmount;
            }

            if (data.itemArray.length > 0) {
              this.itemArrayShow = data.itemArray;
            }
            //   this.total = 0;
            // this.subConditionArray.map((x, index) => {
            //   this.total = parseFloat(x.materialCost) + parseFloat(this.total);
            // });

         
            // this.$refs["addPop1"].close();
            // this.itemModal = "";
            this.getData();
          }
        })
        .catch(error => {});
    },

    itemMasterFilter(list, query) {
      return this.itemDetail.filter(x => {
        return x.itemNameCode.toLowerCase().includes(query.toLowerCase());
      });
    },

    // locationMasterFilter(list, query) {
    //   return this.locationMaster.filter(x => {
    //     return x.pickupLocation.toLowerCase().includes(query.toLowerCase());
    //   });
    // },

    employeeMasterFilter(list, query) {
      return this.employeeMaster.filter(x => {
        return x.employeeName.toLowerCase().includes(query.toLowerCase());
      });
    },

    previosMaintain() {
      this.$router.push({
        path: "/yard/viewGateIn"
      });
    },

    requestForMaintain(userstatus) {
      //  this.validateJobOrder();

      //if (this.validate != false) {

      if (userstatus == "employee") {
        this.ContainerDetail["maintenanceRequest"] = "Sent For Approval";
      }
      this.ContainerDetail["userstatus"] = userstatus;
      $("#addButtonLoader3").css("display", "none");
      $("#loader3").css("display", "block");
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/addGateInContainer.php`,
        data: JSON.stringify(this.ContainerDetail),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;

          if ( status == 200 && data) {
            // this.serviceDetails.itemForServiceEstId += ",";
            $("#loader3").css("display", "none");
            $("#addButtonLoader3").css("display", "block");
            this.alert.content = "Request Sent For Approval";
            this.$refs["addPop11"].open();
          }
        })
        .catch(error => {});
    },
    openItemDialog() {
      this.$refs["dialog"].open();
    },
    addAmountIndex(index, id, indexNew) {
      let val = $("#materialCost" + id).val();

      let payload = {
        materialCost: val,
        mainId: id
      };

      this.subConditionArray[indexNew]["materialCost"] = val;

      this.viewEstimatedAmountNew();

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/addEstimationAmount.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
          }
        })
        .catch(error => {});
    },

    viewEstimatedAmountNew() {
      if (this.subConditionArray.length > 0) {
        let amount = 0;

        this.subConditionArray.map(x => {
          amount = amount + parseFloat(x.materialCost);
        });
        this.ContainerDetail.estimationAmount = amount;
      }
    },
    viewStockDetail() {
      let payload = {
        editJob: "editJob",
        maintainenceId: this.$sessionsStorage.get("editMaintainenceRepId")
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/viewMaintanenceDetail.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if (
            data.clientId != "" &&
            
            status == 200 &&
            data
          ) {
            // if (data.maintainenceId != "") {
            //   this.$sessionsStorage.set("editMaintainenceRepId", data.maintainenceId);
            // }

            Object.keys(data.editJob[0]).map(x => {
              this.maintain[x] = data.editJob[0][x] || "";
            });
           

            this.maintain.itemMasterId += ",";

            this.poItemView(this.maintain.itemMasterId);
          }
        })
        .catch(error => {});
    },
    poItemView(poItemId) {
      this.itemArrayShow = [];

      let payload = {
        itemMaintainenceId: this.maintain.itemMasterId
      };

      payload["maintainenceId"] = "";

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/viewMaintainenceItem.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.itemArray.length > 0) {
              this.itemArrayShow = data.itemArray;
            }

            // this.$refs["addPop1"].close();
            // this.itemModal = "";
            this.getData();
          }
        })
        .catch(error => {});
    },

    validateJobOrder() {
      let validate_new = true;

      if (this.subContainer.repairId == "") {
        $("#repairId").focus();
        this.containerConditionError = "Select Repair Condition";
        validate_new = false;
      } else {
        this.containerConditionError = "";
      }

      if (this.subContainer.repairSubId == "") {
        $("#containerRemark").focus();
        this.subConditionError = "Select Sub Condition";
        validate_new = false;
      } else {
        this.subConditionError = "";
      }
      if (this.subContainer.repairSideId == "") {
        $("#repairSideId").focus();
        this.repairSideIdError = "Select  Side Condition";
        validate_new = false;
      } else {
        this.repairSideIdError = "";
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    validateSurvey() {
      let validate_new = true;

      if (this.ContainerDetail.repairStatus == "") {
        $("#repairStatus").focus();
        this.repairStatusError = "Select Repair Status";
        validate_new = false;
      } else {
        this.repairStatusError = "";
      }

      if (
        this.ContainerDetail.repairCompletedNot == "Repair_Done" &&
        this.ContainerDetail.uploadRepairDone == ""
      ) {
        console.log("fdsfsdfsdfds");
        this.uploadFileError = "Upload File";
        validate_new = false;
      } else {
        this.uploadFileError = "";
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    updateContainerCondition() {
      this.validateJobOrder();
      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Yard/updateContainerCondition.php`,
          data: JSON.stringify(this.subContainer),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
            if (this.subContainer.updateConditionId != "") {
              this.alert.content = "Data Updated Successfully";
            } else {
              this.alert.content = "Data Added Successfully";
            }

            this.$refs["addPopSubCon"].open();
            this.subContainer.containerRemark = "";
            this.subContainer.repairId = "";
            this.subContainer.repairSideId = "";
            this.subContainer.repairSubId = "";
            this.subContainer.materialCost = "";
            this.subContainer.subContainerCondition = "";
          })

          .catch(error => {});
      }
    }
  }
};
</script>
<style>
.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.md-dialog-container.HereDialog.md-theme-default {
  z-index: 1;
}

.md-dialog-container.HereDialog.md-theme-default .md-dialog {
  width: 50%;
  height: 50%;
}
.md-select-content {
  z-index: 999999999;
}
.marg-top {
  margin-top: 0%;
}
</style>


// WEBPACK FOOTER //
// editContainerRepair.vue?bf7fbe20